module.exports = __webpack_public_path__ + "img/logo-full.9c8b8d8.svg";